export default "__VITE_ASSET__CYVLucnm__"